<template>
  <div class="cy-sanitary-equipment">
    <div v-html="$t('sanitary_equipment.choose.description')"></div>

    <item-block v-for="(item, i) in choosableItems" :key="'choosable-item-' + i">
      <base-subheader>
        {{ item.title }}
      </base-subheader>
      <LargeMultiSliderSelector
        v-if="$vuetify.breakpoint.mdAndUp"
        mandatory
        :items="item.options"
        :value="$store.state.sanitary_equipment[item.slug]"
        @input="set(item.slug, $event)"
      />
      <RadioSelector
        v-else
        :items="item.options"
        :value="$store.state.sanitary_equipment[item.slug]"
        @input="set(item.slug, $event)"
      />
    </item-block>
  </div>
</template>

<script>
import RadioSelector from '../../RadioSelector';
import LargeMultiSliderSelector from "../../LargeMultiSliderSelector";
export default {
  components: {
    LargeMultiSliderSelector,
        RadioSelector
  },

  computed: {
    choosableItems() {
      const items = this.$store.state.options.sanitary_equipment_options;
      return items.map((el) => {
        return { ...el, options: this.mapOptions(el.options) };
      });
    },
  },

  methods: {
    set(key, value) {
      const updatables = {};
      updatables[key] = value;
      this.$store.dispatch("setSanitaryEquipment", updatables);
    },

    mapOptions(options) {
      return options.map((el) => {
        return {
          ...el,
          chip: el.price ? el.price + " €" : null,
        };
      });
    },
  },
};
</script>
